import React, { Component } from 'react'
import PropTypes from 'prop-types'

import _ from 'lodash'

import MetaImage from './MetaImage'
import MetaSign from './MetaSign'
import MetaVoice from './MetaVoice'
import MetaText from './MetaText'
import MetaCheck from './MetaCheck'
import MetaRadio from './MetaRadio'

import './MetaLayer.css'

export default class MetaLayer extends Component {
    renderMetaItem(meta) {
        let position = {
            'width': meta.width * this.props.showRatio + 'px',
            'height': meta.height * this.props.showRatio + 'px',
            'top': meta.upy * this.props.showRatio + 'px',
            'left': meta.upx * this.props.showRatio + 'px',
        }

        if (meta.metaKey === 'META_TEXT_INFO') {
            return <MetaText text={meta.value} position={position} showRatio={this.props.showRatio} key={`TEXT${meta.index}`} type={meta.metaKey} index={meta.index} showInputMeta={this.props.showInputMeta}/>
        } else if (meta.metaKey === 'META_CHECK_INFO') {
            return <MetaCheck checked={meta.value} position={position} key={`CHECK${meta.index}`} index={meta.index} type={meta.metaKey} setMetaData={this.props.setCheckMeta} />
        } else if (meta.metaKey === 'META_RADIO_INFO') {
        } else if (meta.metaKey === 'META_RADIO_SUB_INFO') {
            return <MetaRadio checked={meta.value} position={position} key={`Radio${meta.child_index}`} group={meta.parent_index} index={meta.child_index} type={meta.metaKey} setMetaData={this.props.setRadioMeta} />
        } else if (meta.metaKey === 'META_SIGNVECTOR_INFO') {
        } else if (meta.metaKey === 'META_IMAGE_INFO') {
            return <MetaImage image={meta.value ? meta.value.imageUrl : ''} position={position} key={`IMAGE${meta.index}`} index={meta.index} type={meta.metaKey} showInputMeta={this.props.showInputMeta} />
        } else if (meta.metaKey === 'META_SIGN_INFO') {
            return <MetaSign sign={meta.value} position={position} key={`SIGN${meta.index}`} index={meta.index} type={meta.metaKey} showInputMeta={this.props.showInputMeta}/>
        } else if (meta.metaKey ==='META_VOICE_INFO') {
            return <MetaVoice sound={meta.value ? meta.value.soundUrl : ''} image={meta.value ? meta.value.imageUrl : ''} position={position} key={`VOICE${meta.index}`} index={meta.index} type={meta.metaKey} showInputMeta={this.props.showInputMeta}/>
        }
    }

    render() {
        return (
            <div className='metaLayer'>
            {
                this.props.metas.map((value) => {
                    return this.renderMetaItem(value)
                })
            }
            </div>
        )
    }
}

MetaLayer.propTypes = {
    metas: PropTypes.array.isRequired,
    showRatio: PropTypes.number,
    showInputMeta: PropTypes.func,
    setCheckMeta: PropTypes.func,
    setRadioMeta: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/components/MetaLayer.js